module.exports = __webpack_public_path__ + "static/media/512aloma.d4b2505f.png";